const Fields = {
  ACCEPT_URL: 'accept_url',
  ACCOUNT_BIC: 'account_bic',
  ACCOUNT_HOLDER_FIRST_NAME: 'account_holder_first_name',
  ACCOUNT_HOLDER_LAST_NAME: 'account_holder_last_name',
  ACCOUNT_IBAN: 'account_iban',
  ACCOUNT_NUMBER: 'account_number',
  ACCOUNT_ROUTING_NUMBER: 'account_routing_number',
  APM_CODE: 'apm_code',
  ATTEMPTS_REMAINING: 'attempts_remaining',
  AUTHENTICATION_DATE: 'authentication_date',
  AUTHENTICATION_PARTNER: 'authentication_partner',
  AUTHENTICATION_REQUEST_DATE: 'authentication_request_date',
  AUTHENTICATION_REQUEST_STATUS: 'authentication_request_status',
  AUTHENTICATION_RESULT: 'authentication_result',
  AUTHORIZATION_CODE: 'authorization_code',
  AUTHORIZATION_DATE: 'authorization_date',
  AUTHORIZATION_REQUEST_DATE: 'authorization_request_date',
  AUTHORIZATION_REQUEST_STATUS: 'authorization_request_status',
  AUTHORIZATION_RESULT: 'authorization_result',
  AUTHORIZATION_STATUS: 'authorization_status',
  BASKET_TYPE: 'basket_type',
  CANCELLATION_DATE: 'cancellation_date',
  CANCELLATION_REQUEST_DATE: 'cancellation_request_date',
  CANCELLATION_REQUEST_STATUS: 'cancellation_request_status',
  CANCELLATION_RESULT: 'cancellation_result',
  CANCELLATION_STATUS: 'cancellation_status',
  CAPTURED_AMOUNT: 'captured_amount',
  CAPTURE_DATE: 'capture_date',
  CAPTURE_REQUEST_DATE: 'capture_request_date',
  CAPTURE_REQUEST_STATUS: 'capture_request_status',
  CAPTURE_RESULT: 'capture_result',
  CAPTURE_STATUS: 'capture_status',
  CARD_4_DIGITS: 'card_4_digits',
  CARD_6_DIGITS: 'card_6_digits',
  CARD_COUNTRY: 'card_country',
  CARD_ENROLLED: 'card_enrolled',
  CARD_ISSUER: 'card_issuer',
  CARD_NUMBER: 'card_number',
  CASHIER_FILE_DATE: 'cashier_file_date',
  CASHIER_FILE_ID: 'cashier_file_id',
  CASHIER_FILE_NAME: 'cashier_file_name',
  CASHIER_PARTNER: 'cashier_partner',
  CHALLENGE_PREFERENCE: 'challenge_preference',
  CHARGEBACK_AMOUNT: 'chargeback_amount',
  CHARGEBACK_DATE: 'chargeback_date',
  CHARGEBACK_REASON: 'chargeback_reason',
  CHARGEBACK_REASON_CODE: 'chargeback_reason_code',
  CMS_NAME: 'cms_name',
  CMS_VERSION: 'cms_version',
  CURRENCY: 'currency',
  CUSTOMER_ACCOUNT_CHANGE_DATE: 'customer_account_change_date',
  CUSTOMER_ACCOUNT_CREATION_DATE: 'customer_account_creation_date',
  CUSTOMER_ACCOUNT_LOGIN_TYPE: 'customer_account_login_type',
  CUSTOMER_BILLING_CITY: 'customer_billing_city',
  CUSTOMER_BILLING_COUNTRY: 'customer_billing_country',
  CUSTOMER_BILLING_FIRST_NAME: 'customer_billing_first_name',
  CUSTOMER_BILLING_LAST_NAME: 'customer_billing_last_name',
  CUSTOMER_BILLING_STATE: 'customer_billing_state',
  CUSTOMER_BILLING_STREET_NAME: 'customer_billing_street_name',
  CUSTOMER_BILLING_ZIP_CODE: 'customer_billing_zip_code',
  CUSTOMER_BIRTH_DATE: 'customer_birthdate',
  CUSTOMER_CITY: 'customer_city',
  CUSTOMER_COUNTRY: 'customer_country',
  CUSTOMER_EMAIL: 'customer_email',
  CUSTOMER_FIRST_NAME: 'customer_first_name',
  CUSTOMER_ID: 'customer_id',
  CUSTOMER_IP: 'customer_ip',
  CUSTOMER_IP_COUNTRY: 'customer_ip_country',
  CUSTOMER_LAST_NAME: 'customer_last_name',
  CUSTOMER_PHONE_NUMBER: 'customer_phone_number',
  CUSTOMER_PHONE_NUMBER_TYPE: 'customer_phone_number_type',
  CUSTOMER_STATE: 'customer_state',
  CUSTOMER_STREET_NAME: 'customer_street_name',
  CUSTOMER_ZIP_CODE: 'customer_zip_code',
  DECLINE_URL: 'decline_url',
  DEVICE_TYPE: 'device_type',
  EXCEPTION_URL: 'exception_url',
  GIFTCARD_AMOUNT: 'giftcard_amount',
  GIFTCARD_CURRENCY: 'giftcard_currency',
  GIFTCARD_NUMBER: 'giftcard_number',
  GIFTCARD_USED: 'giftcard_used',
  HOLDER: 'holder',
  INTEGRATION_TYPE: 'integration_type',
  IS_AUTHENTICATED: 'is_authenticated',
  IS_AUTHORIZED: 'is_authorized',
  IS_CANCELLED: 'is_cancelled',
  IS_CAPTURED: 'is_captured',
  IS_CHARGEBACKED: 'is_chargebacked',
  IS_CUSTOMER_REGISTERED: 'is_customer_registered',
  IS_FALLBACK: 'is_fallback',
  IS_NEW_TRANSACTION: 'is_new_transaction',
  IS_ORDER_LAST_TRANSACTION: 'is_order_last_transaction',
  IS_REFUNDED: 'is_refunded',
  IS_RETURN_ACCEPTED: 'is_return_accepted',
  LIABILITY_SHIFT: 'liability_shift',
  MAX_ATTEMPTS: 'max_attempts',
  MERCHANT_ACCOUNT: 'merchant_account',
  MERCHANT_ACCOUNT_NAME: 'merchant_account_name',
  MERCHANT_CONTRACT: 'merchant_contract',
  MERCHANT_CONTRACT_NAME: 'merchant_contract_name',
  MERCHANT_DATA: 'merchant_data',
  MERCHANT_ROUTE: 'merchant_route',
  MERCHANT_STORE_ID: 'merchant_store_id',
  MERCHANT_TERMINAL_ID: 'merchant_terminal_id',
  ORDER_AMOUNT: 'order_amount',
  ORDER_DESCRIPTION: 'order_description',
  ORDER_ID: 'order_id',
  ORDER_MERCHANT_ID: 'order_merchant_id',
  ORDER_STATUS: 'order_status',
  PAYIN_PARTNER: 'payin_partner',
  PAYMENT_CHANNEL: 'payment_channel',
  PAYMENT_METHOD: 'payment_method',
  PAYMENT_METHOD_TYPE: 'payment_method_type',
  PENDING_URL: 'pending_url',
  PLAN_ID: 'plan_id',
  PSP_AUTHENTICATION_ID: 'psp_authentication_id',
  PSP_RESULT_CODE: 'psp_result_code',
  PSP_RESULT_DESCRIPTION: 'psp_result_description',
  PSP_TOKEN: 'psp_token',
  PSP_TRANSACTION_DATE: 'psp_transaction_date',
  PSP_TRANSACTION_ID: 'psp_transaction_id',
  RECURRING: 'recurring',
  REFUNDED_AMOUNT: 'refunded_amount',
  REFUND_DATE: 'refund_date',
  REFUND_REASON: 'refund_reason',
  REFUND_REQUEST_DATE: 'refund_request_date',
  REFUND_REQUEST_STATUS: 'refund_request_status',
  REFUND_STATUS: 'refund_status',
  RESULT_CODE: 'result_code',
  RESULT_DESCRIPTION: 'result_description',
  RISK_ASSESSMENT_DATE: 'risk_assessment_date',
  RISK_ASSESSMENT_DEVICE_FINGERPRINT: 'risk_assessment_device_fingerprint',
  RISK_ASSESSMENT_PARTNER: 'risk_assessment_partner',
  RISK_ASSESSMENT_REASON: 'risk_assessment_reason',
  RISK_ASSESSMENT_REASON_CODE: 'risk_assessment_reason_code',
  RISK_ASSESSMENT_RESULT: 'risk_assessment_result',
  RISK_ASSESSMENT_SCORE: 'risk_assessment_score',
  ROUTING_MODE: 'routing_mode',
  ROUTING_RULE: 'routing_rule',
  ROUTING_RULE_VERSION: 'routing_rule_version',
  SCA_EXEMPTION_REASON: 'sca_exemption_reason',
  SCHEDULED_CAPTURE_DATE: 'scheduled_capture_date',
  SCHEME_AUTHENTICATION_ID: 'scheme_authentication_id',
  SCHEME_CUSTOMER: 'scheme_customer',
  SCHEME_REAL: 'scheme_real',
  SCHEME_SECONDARY: 'scheme_secondary',
  SHIPPING_ADDRESS_CITY: 'shipping_address_city',
  SHIPPING_ADDRESS_COUNTRY: 'shipping_address_country',
  SHIPPING_ADDRESS_EMAIL: 'shipping_address_email',
  SHIPPING_ADDRESS_FIRST_USE_DATE: 'shipping_address_first_use_date',
  SHIPPING_ADDRESS_STATE: 'shipping_address_state',
  SHIPPING_ADDRESS_STREET_NAME_LINE1: 'shipping_address_street_name_line1',
  SHIPPING_ADDRESS_STREET_NAME_LINE2: 'shipping_address_street_name_line2',
  SHIPPING_ADDRESS_ZIP_CODE: 'shipping_address_zip_code',
  SHIPPING_CARRIER_NAME: 'shipping_carrier_name',
  SHIPPING_DELIVERY_METHOD: 'shipping_delivery_method',
  SHIPPING_DELIVERY_RANGE: 'shipping_delivery_range',
  SHIPPING_FIRST_NAME: 'shipping_first_name',
  SHIPPING_ID: 'shipping_id',
  SHIPPING_LAST_NAME: 'shipping_last_name',
  SHIPPING_PHONE_NUMBER: 'shipping_phone_number',
  SHIPPING_PRICE: 'shipping_price',
  SHIPPING_TAX: 'shipping_tax',
  SHIPPING_TAX_RATE: 'shipping_tax_rate',
  SOURCE: 'source',
  SUBSCRIBER_ID: 'subscriber_id',
  SUBSCRIPTION_COUNT: 'subscription_count',
  SUBSCRIPTION_DESCRIPTION: 'subscription_description',
  SUBSCRIPTION_END_DATE: 'subscription_end_date',
  SUBSCRIPTION_ID: 'subscription_id',
  SUBSCRIPTION_RECURRENCE: 'subscription_recurrence',
  TOKEN: 'token',
  TRANSACTION_AMOUNT: 'transaction_amount',
  TRANSACTION_CREATION_DATE: 'transaction_creation_date',
  TRANSACTION_ID: 'transaction_id',
  TRANSACTION_STATUS: 'transaction_status',
  TRANSACTION_UPDATE_DATE: 'transaction_update_date',
  TYPE: 'type',
  UPDATE_DATE: 'update_date',
  WEBSITE_URL: 'website_url',
  FINANCIAL_OPERATION_ID: 'financial_operation_id',
  FINANCIAL_OPERATION_TYPE: 'financial_operation_type',
  FINANCIAL_OPERATION_FEE_TYPE: 'financial_operation_fee_type',
  FINANCIAL_OPERATION_AMOUNT: 'financial_operation_amount',
  FINANCIAL_OPERATION_CURRENCY: 'financial_operation_currency',
  FINANCIAL_OPERATION_MOVEMENT: 'financial_operation_movement',
  FINANCIAL_OPERATION_CREATED_AT: 'financial_operation_created_at',
  OPERATION_ID: 'operation_id',
  OPERATION_TYPE: 'operation_type',
  INBOUND_BATCH_DATE: 'inbound_batch_date',
  INBOUND_BATCH_ID: 'inbound_batch_id',
  CARD_CATEGORY: 'card_category',
  CARD_ISSUING_COUNTRY: 'card_issuing_country',
  CARD_TYPE: 'card_type',
  ENVIRONMENT: 'environment',
  INTERCHANGE_ZONE: 'interchange_zone',
  MERCHANT_ACCOUNT_COUNTRY: 'merchant_account_country',
  PARTNER_CARD_CATEGORY: 'partner_card_category',
  PARTNER_CARD_TYPE: 'partner_card_type',
  PARTNER_OPERATION_ID: 'partner_operation_id',
  PARTNER_OPERATION_DATE: 'partner_operation_date',
  PARTNER_OPERATION_STATUS: 'partner_operation_status',
  PARTNER_TYPE: 'partner_type',
  RECONCILIATION_FILE_NAME: 'reconciliation_file_name',
  SETTLEMENT_ID: 'settlement_id',
  SETTLEMENT_DATE: 'settlement_date',
  PARTNER_INVOICE_NUMBER: 'partner_invoice_number',
  ORDER_CREATION_DATE: 'order_creation_date',
  ORDER_IS_RECONCILED: 'order_is_reconciled',
  ORDER_RECONCILED_AMOUNT: 'order_reconciled_amount',
  ORDER_UNRECONCILED_AMOUNT: 'order_unreconciled_amount',
  IS_RECONCILED: 'is_reconciled',
  RECONCILED_AMOUNT: 'reconciled_amount',
  UNRECONCILED_AMOUNT: 'unreconciled_amount',
  RECONCILIATION_REASON: 'reconciliation_reason',
  WITHDRAW_REASON: 'withdraw_reason',
  RECONCILIATION_NOTE: 'reconciliation_note',
  RECONCILIATION_AUTHOR_EMAIL: 'reconciliation_author_email',
  RECONCILIATION_DATE: 'reconciliation_date',
  RECONCILIATION_TYPE: 'reconciliation_type',
  ORDER_TRANSACTIONS_COUNT: 'order_transactions_count',
  // NOTIFICATION
  NOTIFICATION_DATE: 'notification_date',
  NOTIFICATION_CALLS: 'notification_calls',
  NOTIFICATION_RESULT_CODE: 'notification_result_code',
  NOTIFICATION_STATUS: 'notification_status',
  NOTIFICATION_TRIGGER: 'notification_trigger',
  NOTIFICATION_ID: 'notification_id',
  NOTIFICATION_URL: 'notification_url',
  NOTIFICATION_WEBHOOK: 'notification_webhook',
  NOTIFICATION_TRANSACTION_ID: 'notification_transaction_id',
  NOTIFICATION_ORDER_ID: 'notification_order_id',
  NOTIFICATION_MERCHANT_ACCOUNT: 'notification_merchant_account',
  NOTIFICATION_MERCHANT_ACCOUNT_NAME: 'notification_merchant_account_name',
  // ADMIN
  COMPANY: 'company',
  PROGRAM_MANAGER: 'program_manager',
  NOTIFICATION_COMPANY: 'notification_company',
  NOTIFICATION_PROGRAM_MANAGER: 'notification_program_manager',
  // LOG
  LOG_CREATED_AT: 'log_created_at',
  LOG_AUTHOR_EMAIL: 'log_author_email',
  LOG_AUTHOR_FULL_NAME: 'log_author_full_name',
  LOG_ENTITY_TYPE: 'log_entity_type',
  LOG_ENTITY_NAME: 'log_entity_name',
  LOG_ENTITY_ID: 'log_entity_id',
  LOG_MERCHANT_ACCOUNT_NAME: 'log_merchant_account_name',
  LOG_MERCHANT_ACCOUNT_ID: 'log_merchant_account_id',
  LOG_UPDATE: 'log_update',
  LOG_IP: 'log_ip',
  // CHECKOUT
  CHECKOUT_ID: 'checkout_id',
  CHECKOUT_CREATION_DATE: 'checkout_creation_date',
  CHECKOUT_UPDATE_DATE: 'checkout_update_date',
  CHECKOUT_TYPE: 'checkout_type',
  CHECKOUT_EXPIRATION_DATE: 'checkout_expiration_date',
  CHECKOUT_CUSTOMER_EMAIL: 'checkout_customer_email',
  CHECKOUT_CUSTOMER_ID: 'checkout_customer_id',
  TOKEN_TYPE: 'token_type',
  CHECKOUT_AMOUNT: 'checkout_amount',
  CHECKOUT_CURRENCY: 'checkout_currency',
  CHECKOUT_ORDERS_COUNT: 'orders_count',
  CHECKOUT_TRANSACTIONS_COUNT: 'transactions_count',
};

module.exports = Fields;
